<template>
  <div :class="stepClasses">
    <div :class="componentClasses">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import seo from './../classes/SEO';

  export default {
    props: {
      stepKey: {
        type: String,
        required: true,
      },

      eventValue: {
        type: Number,
      },

      eventLabel: {
        type: String,
      },
    },

    data: () => ({
      active: false,
      eventFired: false
    }),
    watch: {
      active(value) {
          if(value) {
              window.scrollTo({ top: 0, behavior: 'smooth' });
          }
      }
    },

    computed: {
      stepClasses() {
        let modifierClass = `wizard__step--${this.key}`;

        return {
          'wizard__step': true,
          'wizard__step--active': this.active,
          [modifierClass]: true
        }
      },

      componentClasses() {
        let modifierClass = `wizard__component--${this.key}`;

        return {
          'wizard__component': true,
          [modifierClass]: true
        }
      }
    },


    mounted() {
    },

    updated() {
      this.sendTrackingEvent();
    },

    methods: {
      sendTrackingEvent() {
        if (!this.active || !this.eventValue || !this.eventLabel || this.eventFired) {
          return;
        }

        seo.sendWizardEvent({
          eventLabel: this.eventLabel,
          eventValue: this.eventValue,
        });
        this.eventFired = true;
      },
    }
  };
</script>
